// extracted by mini-css-extract-plugin
module.exports = {"modal":"SettingsBG-modal-1XSR2"};